import { Typography } from "antd";
import { useInsightMenuItems } from "./InsightCardMenuItems";
import { InsightProps } from "./insights";
import InsightAvatar from "./InsightAvatar";
import { formattedDate } from "@/utils/dateUtils";
import { capitalizeFirst } from "@/utils/textFormattingUtils";
import MenuDropdown from "./MenuDropdown";
import { isInsightArchived } from "./utils";
import CadenceIcon from "@/assets/icons/CadenceIcon.svg?react";
import SharedIcon from "@/assets/icons/SharedIcon.svg?react";

export default function CompactInsightCard({
  insight,
  onOpenDrawer,
  onOpenEditModal,
  onArchiveInsight,
  onOpenDeleteModal,
  onOpenDeleteAlertModal,
  onActivateInsight,
  onOpenAddAlertModal,
  userName,
  onOpenShareModal,
}: {
  insight: InsightProps;
  onOpenDrawer: (insight: InsightProps) => void;
  onOpenEditModal: () => void;
  onArchiveInsight: () => void;
  onOpenDeleteModal: () => void;
  onOpenDeleteAlertModal: () => void;
  onActivateInsight: () => void;
  onOpenAddAlertModal: () => void;
  userName?: string;
  onOpenShareModal?: () => void;
}) {
  const items = useInsightMenuItems({
    insight,
    onOpenEditModal,
    onArchiveInsight,
    onOpenDeleteModal,
    onOpenDeleteAlertModal,
    onActivateInsight,
    onOpenAddAlertModal,
    onOpenShareModal,
  });

  if (!insight) return null;

  return (
    <div
      data-testid="insight-card"
      className="flex items-center bg-white p-3 rounded-lg gap-3 hover:shadow-md transition-shadow duration-200 cursor-pointer"
      onClick={() => {
        onOpenDrawer(insight);
      }}
    >
      <span data-testid={`insight-card-${insight.id}`} />
      <div className="flex items-center gap-3 min-w-0 flex-1">
        <InsightAvatar insight={insight} userName={userName} />
        <Typography.Text
          className="text-[#2B4752] text-base font-normal"
          ellipsis={{
            tooltip: insight.title,
          }}
          style={{ margin: 0, width: "100%" }}
        >
          {capitalizeFirst(insight.title)}
        </Typography.Text>
      </div>

      <div className="flex items-center gap-3 shrink-0">
        <p className="text-[#00000073] text-sm whitespace-nowrap">
          {formattedDate(insight?.insight_result_timestamp, "en-US")}
        </p>
        {!isInsightArchived(insight) && (
          <div className="flex items-center gap-1">
            <CadenceIcon className="w-4 h-4" />
            <p className="text-[#00000073] text-sm whitespace-nowrap">
              {capitalizeFirst(insight.cadence)}
            </p>
          </div>
        )}
        {insight.is_shared && (
          <div className="flex items-center gap-1 text-[#00000073]">
            <SharedIcon className="w-4 h-4" />
            <p className="text-sm whitespace-nowrap">Shared</p>
          </div>
        )}
        <MenuDropdown items={Array.isArray(items) ? items : []} />
      </div>
    </div>
  );
}
